import { gql } from '@apollo/client';

export const GET_CASHFLOWS = gql`
  query CashflowGraphs(
    $portfolioId: String!
    $asOfDate: String!
    $scenarioName: String!
    $freqType: String!
    $skip: Int
    $take: Int
  ) {
    cashflowGraphs(
      portfolioId: $portfolioId
      asOfDate: $asOfDate
      scenarioName: $scenarioName
      freqType: $freqType
      skip: $skip
      take: $take
    ) {
      recId
      portfolioId
      asOfDate
      freqType
      scenario
      scenarioName
      cfPeriod
      apmRptSecClass
      secClass
      secClassLongDesc
      secClassShortDesc
      scenarioSortOrder
      secClassSortOrder
      reportRGB
      reportHex
      totalPrincipal
      totalInterest
      totalPandI
      positionCount
      wtdAvgProjectedYield
      lastUpdatedDate
      lastUpdatedBy
      institutionName
      institutionCity
      institutionState
    }
  }
`;
